import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getMenu } from '../../api/axios/crux/business'

export const fetchGnbMenu = createAsyncThunk('gnb/fetchGnbMenu', async () => {
  const { data } = await getMenu()
  return data
})
const gnbSlice = createSlice({
  name: 'gnb',

  initialState: {
    isLoading: false,
    home: undefined,
    serviceMenu: [],
    myMenu: [],
  },

  extraReducers: builder => {
    builder.addCase(fetchGnbMenu.pending, state => {
      state.isLoading = true
    })

    builder.addCase(
      fetchGnbMenu.fulfilled,
      (state, { payload: { home, serviceMenu, myMenu } }) => {
        state.home = home
        state.serviceMenu = serviceMenu
        state.myMenu = myMenu
        state.isLoading = false
      }
    )

    builder.addCase(fetchGnbMenu.rejected, state => {
      state.isLoading = false
    })
  },
})
const { reducer } = gnbSlice
export default reducer
